export const terms = [
  "Create an account to place orders, write reviews, like posts, and track book views.",
  "Orders move from Paused to Process after payment confirmation, then to Finished when received.",
  "Reviews must remain respectful. Moderators may block or delete inappropriate content.",
  "All activity is managed by BooClub administration. Please follow community guidelines.",
];
